export const key = 'key';
export const label = 'label';
export const name = 'name';
export const value = 'value';

export function cleanProps(props) {
  Object.keys(props).forEach((key) => {
    if (!props[key]) {
      delete props[key];
    }
  });

  return props;
}

export function hasProp(...args) {
  return Object.prototype.hasOwnProperty.call(...args);
}
